import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Card, CardBody, CardTitle, CardText, Spinner } from 'reactstrap';
import { BASE_URL } from '../../constants';

function Notification() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(5); 
    const loadingRef = useRef(null);

    const fetchNotifications = () => {
        const token = localStorage.getItem('token');
        if (token) {
            fetch(`${BASE_URL}/notification/list?per_page=${perPage}&page_no=${pageNo}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        const formattedNotifications = data.result.data.map(notification => ({
                            ...notification,
                            created_at: notification.created_at ? new Date(notification.created_at).toLocaleDateString('en-US') : "N/A"
                        }));

                        setNotifications(prev => [...prev, ...formattedNotifications]);
                    } else {
                        console.error("Error: Unable to fetch notifications.");
                    }
                })
                .catch(error => console.error("Error fetching notifications:", error))
                .finally(() => setLoading(false));
        } else {
            console.error("Error: Authorization token is missing.");
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, [pageNo]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setPageNo(prev => prev + 1);
            }
        }, {
            threshold: 1.0, 
        });

        if (loadingRef.current) {
            observer.observe(loadingRef.current);
        }

        return () => {
            if (loadingRef.current) {
                observer.unobserve(loadingRef.current);
            }
        };
    }, [loadingRef.current]);

    return (
        <div className="content">
            <h3>Notifications</h3>
            {loading && notifications.length === 0 ? (
                <Spinner color="primary" />
            ) : notifications.length === 0 ? (
                <p>No notifications available.</p>
            ) : (
                <div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {notifications.map(notification => (
                            <Card key={notification.id} style={{ backgroundColor: 'white', color: 'rgba(70,70,70,1.0)', width: '70%', height: '100px', marginBottom: '10px' }}>
                                <CardBody>
                                    <CardTitle tag="h5" style={{ fontSize: '16px', margin: '0', fontWeight: 'bold', color: 'rgba(70,70,70,1.0)' }}>
                                        {notification.title}
                                    </CardTitle>
                                    <CardText style={{ fontSize: '14px', margin: '2px 0', color: 'rgba(120,120,120,1.0)' }}>
                                        {notification.body}
                                    </CardText> 
                                    <small style={{ marginTop: '4px', color: 'rgba(150,150,150,1.0)' }}>
                                        {notification.created_at}
                                    </small>
                                </CardBody>
                            </Card>
                        ))}
                    </div>

                    <div ref={loadingRef} style={{ height: '20px', margin: '10px', textAlign: 'center' }}>
                        {loading && <Spinner size="sm" color="primary" />}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Notification;
